"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headers = void 0;
var Headers;
(function (Headers) {
    Headers["KlearAuthHeader"] = "x-klear-authorization";
    Headers["KlearTimestampHeader"] = "x-klear-timestamp";
    Headers["KlearInternalTgw"] = "x-klear-internal-tgw";
    Headers["TwtrlandUserIdHeader"] = "x-klear-twtrland-user-id";
    Headers["ListOwner"] = "list-owner";
    Headers["Collab"] = "collab";
})(Headers = exports.Headers || (exports.Headers = {}));
//# sourceMappingURL=security.enum.js.map